<div>
  <div class="state-collapsible-header" (click)="showTransition = !showTransition">
    <button mat-button (click)="onDeleteTransitionButtonClick()">
      <mat-icon>delete</mat-icon>
    </button>
    <span>{{ transition.Description }}</span>
    <span class="placeholder"></span>
    <div class="clear"></div>
  </div>
  @if (showTransition) {
    <div class="state-collapsible-content">
      <mat-form-field class="state-editor-longfield">
        <input matInput placeholder="Transition Name" [(ngModel)]="transition.Description" required />
      </mat-form-field>
      <br />
      <mat-form-field class="state-editor-longfield">
        <input matInput placeholder="Transition Reason" [(ngModel)]="transition.PostConditionValues.TransitionReason" required />
      </mat-form-field>
      <div>
        <mat-checkbox [(ngModel)]="transition.IsApprovalTransition" aria-label="Is Approval Transition">Is Approval Transition</mat-checkbox>
      </div>
      <div>
        <h4>Post Condition Values <button mat-icon-button (click)="onAddPostConditionValueButtonClick()"><mat-icon>add</mat-icon></button></h4>
        @for (postConditionValue of getPostConditionValueKeysForTransition(); track postConditionValue) {
          <div>
            <mat-form-field class="state-editor-longfield">
              <input matInput placeholder="{{prettifyLabel(postConditionValue)}}" [(ngModel)]="transition.PostConditionValues[postConditionValue]" />
            </mat-form-field>
            <button mat-button (click)="onDeletePostConditionValueButtonClick(postConditionValue)"><mat-icon>delete</mat-icon></button>
          </div>
        }
      </div>
      <h4>Rules <button mat-icon-button (click)="onAddRuleButtonClick()"><mat-icon>add</mat-icon></button></h4>
      @for (rule of getRulesForTransition(); track rule) {
        <my-modules-rule
          [moduleId]="moduleId"
          [rule]="rule"
          [transition]="transition"
          [stateRules]="stateRules"
          [stateRulesToSave]="stateRulesToSave"
          [conditionFields]="conditionFields"
          [listItemsCache]="listItemsCache"
          (editRuleClicked)="createRuleForTransition($event)">
        </my-modules-rule>
      }
    </div>
  }
</div>